import dayjs, { Dayjs } from "dayjs";
import { SortType } from "../../SortType";
import { LeadConversionProbability, LeadSection } from "./LeadAnalytics";

export interface LeadAnalyticsFilters {
  owner_id: string[];
  pipeline_id: string[];
  source_id: string[];
  final_status?: string | null;
  stage_pipeline_id?: number | null;
  conversion_probability?: LeadConversionProbability | null;
  start_date: Dayjs | null;
  end_date: Dayjs | null;
  section: LeadSection;
  page_no: number;
  limit: number;
  sort_by: string;
  sort_type: SortType;
}

export const defaultLeadAnalyticsFilters = (): LeadAnalyticsFilters => ({
  owner_id: [],
  pipeline_id: [],
  source_id: [],
  final_status: null,
  stage_pipeline_id: null,
  conversion_probability: null,
  start_date: dayjs().startOf("month"),
  end_date: dayjs(),
  section: "all",
  page_no: 1,
  limit: 30,
  sort_by: "created_date",
  sort_type: SortType.DESC,
});
